import { ZfBox, ZfFormField, ZfIcon, ZfPopover, ZfSlider, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_INFLATION } from '../../../config/constants';
import { useGeneralSimulationSettings } from '../../../hooks/useGeneralSimulationSettings';
import { roundTo2Decimals } from '../../../utils/utils';

interface IInflationSliderProps {
    padding?: string;
}

export const InflationSlider: FunctionComponent<IInflationSliderProps> = ({ padding }) => {
    const { t } = useTranslation();
    const { settings, patchSettings } = useGeneralSimulationSettings();

    const handleInflationChange = (event: CustomEvent<number>) => patchSettings({ inflationRatePercentage: event.detail / 100 });

    return (
        <ZfBox style={{ padding }}>
            <ZfFormField label={t('inflation')}>
                <ZfSlider
                    value={roundTo2Decimals(settings?.inflationRatePercentage != null ? settings.inflationRatePercentage * 100 : DEFAULT_INFLATION)}
                    valueLabel="%"
                    min={0}
                    max={10}
                    step={0.1}
                    onValueChangeCommitted={handleInflationChange}
                    scalePosition="bottom"
                >
                    <ZfTypography slot="start" variant="label-tiny" color="normal">
                        0%
                    </ZfTypography>
                    <ZfTypography slot="end" variant="label-tiny" color="normal">
                        10%
                    </ZfTypography>
                </ZfSlider>
                <ZfPopover slot="label-trailing" alignment="start">
                    <ZfIcon slot="anchor" size="medium" name="info" style={{ cursor: 'pointer' }} />
                    <ZfTypography variant="label-extra-small" color="normal">
                        {t('inflationInfoBox')}
                    </ZfTypography>
                </ZfPopover>
            </ZfFormField>
        </ZfBox>
    );
};
